import { withOverrideLegacy } from '~/App/hocs/with-override-legacy';

import { SupportMember } from './SupportMember';
import { loadData } from './SupportMember.LoadData';

export default withOverrideLegacy(SupportMember, loadData);
